import { TCommonTaskProp } from '../../types';
import MarkAsCompleteTask from '../../common/tasks/MarkAsCompleteTask';

export const ApproveDataTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  return (
    <MarkAsCompleteTask
      task={task}
      context={context}
      isTimelineView={isTimelineView}
      displayNumber={displayNumber}
    />
  );
};

